/**
 * フォームフィールドの表示/非表示を制御するクラス
 * data-depends-field と data-depends-value 属性に基づいて、
 * フィールドの表示/非表示を切り替える
 */
export class FormFieldVisibilityController {
  private form: HTMLFormElement | null;
  private dependentFields: NodeListOf<HTMLElement>;

  constructor(formSelector: string = 'form') {
    console.log('[FormFieldVisibilityController] Constructor called');
    console.log('[FormFieldVisibilityController] Looking for form with selector:', formSelector);

    this.form = document.querySelector(formSelector);

    if (!this.form) {
      console.warn('[FormFieldVisibilityController] Form not found:', formSelector);
      return;
    }

    console.log('[FormFieldVisibilityController] Form found:', this.form);

    // data-depends-field 属性を持つすべての要素を取得
    this.dependentFields = this.form.querySelectorAll('[data-depends-field]');

    console.log('[FormFieldVisibilityController] Found', this.dependentFields.length, 'dependent fields');

    if (this.dependentFields.length > 0) {
      console.log('[FormFieldVisibilityController] Dependent fields:', this.dependentFields);
    }

    this.init();
  }

  /**
   * 初期化処理
   */
  private init(): void {
    console.log('[FormFieldVisibilityController] init() called');

    if (!this.form) {
      console.error('[FormFieldVisibilityController] Form is null in init()');
      return;
    }

    // 依存するフィールド（customer_typeなど）の変更を監視
    const watchFields = this.getWatchFields();
    console.log('[FormFieldVisibilityController] Watch fields:', watchFields);

    watchFields.forEach(fieldName => {
      console.log('[FormFieldVisibilityController] Setting up listeners for field:', fieldName);

      const field = this.getFieldElement(fieldName);

      if (field) {
        console.log('[FormFieldVisibilityController] Field found:', field);
        console.log('[FormFieldVisibilityController] Field type:', field.type);

        if (field.type === 'radio') {
          // ラジオボタンの場合、すべてのラジオボタンを監視
          const radioButtons = this.form!.querySelectorAll(`input[name="${fieldName}"]`);
          console.log('[FormFieldVisibilityController] Found', radioButtons.length, 'radio buttons');

          radioButtons.forEach((radio, index) => {
            console.log(`[FormFieldVisibilityController] Attaching listener to radio button ${index}:`, radio);
            radio.addEventListener('change', () => {
              console.log('[FormFieldVisibilityController] Radio button changed!');
              this.updateVisibility();
            });
          });
        } else {
          // その他のフィールド
          console.log('[FormFieldVisibilityController] Attaching change listener to:', field);
          field.addEventListener('change', () => {
            console.log('[FormFieldVisibilityController] Field changed!');
            this.updateVisibility();
          });
        }
      } else {
        console.warn('[FormFieldVisibilityController] Field not found:', fieldName);
      }
    });

    // 初期状態の表示/非表示を設定
    console.log('[FormFieldVisibilityController] Calling initial updateVisibility()');
    this.updateVisibility();
  }

  /**
   * 監視対象のフィールド名リストを取得
   */
  private getWatchFields(): string[] {
    const fields = new Set<string>();

    this.dependentFields.forEach(element => {
      const dependsField = element.getAttribute('data-depends-field');
      if (dependsField) {
        fields.add(dependsField);
      }
    });

    return Array.from(fields);
  }

  /**
   * フィールド要素を取得
   */
  private getFieldElement(fieldName: string): HTMLInputElement | HTMLSelectElement | null {
    if (!this.form) return null;

    // ラジオボタンの場合は最初のものを返す（値は全体で取得する）
    const radio = this.form.querySelector(`input[name="${fieldName}"]:checked`) as HTMLInputElement;
    if (radio) return radio;

    // その他のフィールド
    return this.form.querySelector(`[name="${fieldName}"]`) as HTMLInputElement | HTMLSelectElement | null;
  }

  /**
   * フィールドの値を取得
   */
  private getFieldValue(fieldName: string): string {
    if (!this.form) return '';

    // ラジオボタンの場合
    const radio = this.form.querySelector(`input[name="${fieldName}"]:checked`) as HTMLInputElement;
    if (radio) {
      return radio.value;
    }

    // その他のフィールド
    const field = this.form.querySelector(`[name="${fieldName}"]`) as HTMLInputElement | HTMLSelectElement;
    return field ? field.value : '';
  }

  /**
   * すべての依存フィールドの表示/非表示を更新
   */
  private updateVisibility(): void {
    console.log('[FormFieldVisibilityController] Updating visibility...');

    this.dependentFields.forEach(element => {
      const dependsField = element.getAttribute('data-depends-field');
      const dependsValue = element.getAttribute('data-depends-value');

      if (!dependsField || !dependsValue) return;

      const currentValue = this.getFieldValue(dependsField);
      const shouldShow = currentValue === dependsValue;

      console.log('[FormFieldVisibilityController]', {
        element: element.id || element.className,
        dependsField,
        dependsValue,
        currentValue,
        shouldShow
      });

      if (shouldShow) {
        element.classList.remove('is-inactive');
        element.style.display = '';
      } else {
        element.classList.add('is-inactive');
        element.style.display = 'none';

        // カタログセット数フィールドが非表示になる場合、自動的に「1セット」を選択
        if (element.id === 'co-item__number') {
          const catalogQuantitySelect = element.querySelector('select[name="catalog_quantity"]') as HTMLSelectElement;
          if (catalogQuantitySelect) {
            catalogQuantitySelect.value = '1セット';
            console.log('[FormFieldVisibilityController] catalog_quantity auto-set to "1セット"');
          }
        }
      }
    });
  }
}
